module.exports = function loadCond(cond, ifTrue, ifFalse) {
  return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="9498a162-bc67-567d-a7b2-bf12374021d7")}catch(e){}}();
//# debugId=9498a162-bc67-567d-a7b2-bf12374021d7
